import { Panel } from "@poseidon/ui/components/Panel";
import { Button } from "@mui/material";
import { Field } from "formik";
import React from "react";
import EditApplicationFormWrapper from "./EditApplicationFormWrapper";
import DatePicker from "@poseidon/ui/components/form/DatePicker";

export function ApplicationCompletionDatePanel({ application }) {
  const initialValues = {
    id: application.id,
    completionDate: application.completionDate ?? null,
  };
  return (
    <EditApplicationFormWrapper
      initialValues={initialValues}
      application={application}
    >
      {({ isSubmitting, dirty }) => (
        <Panel
          expandable
          title="Completion Date"
          anchorName="completion-date"
          actions={
            <Button
              size="small"
              type="submit"
              disabled={!dirty || isSubmitting}
            >
              Save
            </Button>
          }
        >
          <Field
            component={DatePicker}
            name="completionDate"
            label="Planned Completion Date"
            margin="none"
          />
        </Panel>
      )}
    </EditApplicationFormWrapper>
  );
}
